import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import {
  faCommentSms,
  faEnvelope,
  faInfo,
  faPen,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import timezones from "../../Builder/nodes/Logic/timezones";
import ProjectStartForm from "../../Builder/Components/sidebar/ProjectStartForm";

const inboundIcons = {
  sms: <FontAwesomeIcon icon={faCommentSms} />,
  email: <FontAwesomeIcon icon={faEnvelope} />,
  voice: <FontAwesomeIcon icon={faPhone} />,
};

export default function ComponentCard({ project }) {
  const { countries, defaultTZ, emailDomain } = JSON.parse(
    document.querySelector("#app").dataset.page
  ).props;
  return (
    <div
      className={`card-gradient card h-100 ${
        project.Status === "archived" ? "opacity-50" : ""
      }`}
    >
      <div
        style={{ fontSize: `${0.95}rem` }}
        className="card-body text-white d-flex flex-column justify-content-between gap-3"
      >
        <h4
          className="card-title"
          style={{ height: "3rem" }}
          title={project.Label}
        >
          {project.Label.slice(0, 50)}
          {project.Label.length > 50 ? "..." : ""}
          {project.ActiveProcessCount > 0 && (
            <span
              title="Running processes"
              className="badge text-bg-light float-end"
            >
              {project.ActiveProcessCount}
            </span>
          )}
          {project.Status === "archived" && (
            <span
              title="This project is archived"
              className="badge rounded-circle border border-1 float-end"
            >
              <FontAwesomeIcon icon={faInfo} />
            </span>
          )}
        </h4>
        <div className="div">
          <p className="card-text mb-1 row">
            <span className="text-light col">Description</span>
            <span className="col-8">{project.Description}</span>
          </p>
          <p className="card-text mb-1 row">
            <span className="text-light col">Created at</span>
            <span className="col-8">
              {new Date(project.CreatedAt).toLocaleString()}
            </span>
          </p>
          <p className="card-text mb-1 row">
            <span className="text-light col">Created by</span>
            <span className="col-8">{project.CreatedBy}</span>
          </p>
          <p className="card-text mb-1 row">
            <span className="text-light col col">Status</span>{" "}
            <span className="col-8">{project.Status}</span>
          </p>
          <p className="card-text mb-1 row">
            <span className="text-light col">Country</span>
            <span className="col-8">
              {" "}
              {
                countries.find((c) => c.country_code === project.CountryISO)
                  ?.country_name
              }
            </span>
          </p>
          <p className="card-text mb-1 row">
            <span className="text-light col">Time zone</span>
            <span className="col-8">
              {" "}
              {project.TimeZone
                ? timezones.find((t) => t.tzCode === project.TimeZone)?.label
                : `${
                    timezones.find((t) => t.tzCode === defaultTZ)?.label
                  } (Default)`}
            </span>
          </p>
          <p className="card-text mb-1 row">
            <span className="text-light col">Last run at</span>
            <span className="col-8">
              {" "}
              {project.LastRunAt === "0001-01-01T00:00:00Z"
                ? "N/A"
                : new Date(project.LastRunAt).toLocaleString()}
            </span>
          </p>
          {project.InboundRules &&
            project.InboundRules.map((r) => (
              <p className="row" key={r.ID}>
                <span className="text-light col">Inbound</span>{" "}
                <span className="col-8">
                  {inboundIcons[r.Channel]} {r.Inbound}
                  {r.Channel === "email" ? `@${emailDomain}` : ""}
                </span>
              </p>
            ))}
        </div>
        <div>
          <Link
            to={`/library/logic/builder/${project.ID}`}
            className="btn btn-outline-light btn-sm me-1"
          >
            <FontAwesomeIcon icon={faPen} className="me-2" /> Edit
          </Link>{" "}
          <Link
            className="btn btn-outline-light btn-sm me-1"
            to={`/reporting/processes/${project.ID}`}
          >
            Running: {project.ActiveProcessCount}
          </Link>
          {project.Status === "production" && (
            <ProjectStartForm projectID={project.ID} />
          )}
        </div>
      </div>
    </div>
  );
}
